import * as THREE from "three";
import { TweenLite, Power1 } from "gsap";

export default class HotSpot {
  get Particle() {
    return this._particle;
  }

  set Particle(particle) {
    this._particle = particle;
  }

  get Ring() {
    return this._ring;
  }

  set Ring(ring) {
    this._ring = ring;
  }

  get Circle() {
    return this._circle;
  }

  set Circle(circle) {
    this._circle = circle;
  }

  get IsOver() {
    return this._isOver;
  }

  set IsOver(isOver) {
    this._isOver = isOver;
  }

  get IsOpen() {
    return this._isOpen;
  }

  set IsOpen(isOpen) {
    this._isOpen = isOpen;
  }

  constructor(position, materialCircle, materialRing) {
    let scale = 0.01;
    const circleGeometry = new THREE.PlaneBufferGeometry(
      scale,
      scale,
      scale,
      scale
    );
    scale = 0.05;
    const ringGeometry = new THREE.PlaneBufferGeometry(
      scale,
      scale,
      scale,
      scale
    );

    this.Circle = new THREE.Mesh(circleGeometry, materialCircle);
    this.Ring = new THREE.Mesh(ringGeometry, materialRing);

    this.Particle = new THREE.Group();
    this.Particle.add(this.Circle);
    this.Particle.add(this.Ring);
    this.Particle.renderOrder = 3;

    this.Particle.position.set(position.x, position.y, position.z);
    
    this.IsOpen = true;

    this.close(0);
  }

  close = (time = 0.3) => {
    if (!this.IsOpen) {
      return;
    }

    this.IsOpen = false;
    this.changeScale(this.Ring, 1, 0, time);
    this.changeScale(this.Circle, 1, 0,  time);
  }

  open = (time = 0.3) => {
    if (this.IsOpen) {
      return;
    }

    this.IsOpen = true;
    this.changeScale(this.Ring, 0, 1, time);
    this.changeScale(this.Circle, 0, 1, time);
  }

  mouseOver = () => {
    if (!this.IsOpen || this.IsOver) {
      return;
    }

    this.IsOver = true;
    this.changeScale(this.Ring, 1, 1.1, 0.3, 0.0);
    this.changeScale(this.Circle, 1, 2.5, 0.3, 0.1);
  };

  mouseOut = () => {
    if (!this.IsOpen || !this.IsOver) {
      return;
    }

    this.IsOver = false;
    this.changeScale(this.Ring, 1.2, 1, 0.3, 0.1);
    this.changeScale(this.Circle, 2, 1, 0.3);
  };

  changeScale = (obj, from, to, time = 0.2, delay = 0.0) => {
    if (obj.anim) {
      obj.anim.kill();
    }

    const scale = { scale: from };
    obj.anim = TweenLite.to(scale, time, {
      scale: to,
      ease: Power1.easeOut,
      delay: delay,
      onUpdate: () => {
        obj.scale.set(scale.scale, scale.scale, scale.scale);
      },
    });
  };

  updateCameraPosition = (position) => {
    this.Particle.lookAt(position);
  };
}
